import { BasicInfo } from './BasicInfo'
import { Article } from '@generated'
import CartActions from './CartActions'
import Benefits from './Benefits'
import CtaButtons from '@components/_rolex/CtaButtons'

type ProductDetailsPanelProps = {
  data: Article
}

const ProductDetailsPanel = ({ data }: ProductDetailsPanelProps) => {
  return (
    <div className="flex h-full items-center bg-black py-[60px] pl-[10%] pr-[10%] text-white">
      <div className="w-full overflow-hidden">
        <BasicInfo data={data} />
        <CartActions data={data} />
        <CtaButtons
          phoneNumber="+31 (0)20 622 5333"
          findStore
          sendMessage
          variant="dark"
          className="justify-start"
          isRCPO
        />
        <Benefits />
      </div>
    </div>
  )
}

export default ProductDetailsPanel
